import React, {useEffect, useRef, useState} from "react";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import {Button} from "@material-ui/core";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {
    getBusinesReport,
    getClaimStageReport,
    getExcelData,
    getTariffReport,
    getTariffTestingReport, logoutAPI,
    onboardRoomViaExcel,
    uploadExcel,
} from "../../utils/API";
import {logout} from "../../store/slices/AuthSlice";
import Logo from "../../assets/logo_vitraya_white.png";
import CreateClaim from "../CreateClaim";
import {
    Avatar,
    Checkbox,
    Dialog,
    DialogActions,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    ListItemIcon,
    Menu,
    MenuItem,
} from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import LogoutIcon from "@mui/icons-material/Logout";
import AttachmentIcon from "@mui/icons-material/Attachment";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DateFilter from "./DateFilter";
import moment from "moment";
import {
    isIframeAndAdminUser,
    isIframeAndInsurerUser,
    isIframeUser,
    isVitrayaInternalUser
} from "../../constants/UserAuth";

const Header = (props) => {
    const {setShowSnackbar} = props;
    const theme = useTheme();
    const dispatch = useDispatch();
    const appbarRef = useRef();
    const navigate = useNavigate();
    const email = localStorage.getItem("email");
    const isSmall = useMediaQuery(theme.breakpoints.down("md"));
    const [selectedDocument, setSelectedDocument] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorElReport, setAnchorElReport] = React.useState(null);
    const [excludeFailedCase, setExcludeFailedCase] = useState(false);
    const [includeInsurerFinal, setIncludeInsurerFinal] = useState(false);
    const [openDialog, setOpenDialog] = useState({
        show: false,
        type: "claimReport",
    });
    const [downloading, setDownloading] = useState(false);
    const today = moment(new Date()).format("YYYY-MM-DD");
    // const fifteenDaysAgo = moment().subtract(15, "days").format("YYYY-MM-DD");
    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
    const open = Boolean(anchorEl);

    const logoutHandler = () => {
        logoutAPI().then((isLoggedOut) => {
            if (isLoggedOut.success === true || isLoggedOut.message.code==='USR018') {
                dispatch(logout());
                navigate("/login");
            }
        })
    };

    useEffect(() => {
        selectedDocument.length !== 0 && handleFileUpload();
    }, [selectedDocument]);
    const handleFile = (files) => {
        const selectedDocs = files;
        setSelectedDocument(selectedDocs);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };
    const handleOpenReportMenu = (event) => {
        setAnchorElReport(event.currentTarget);
    };
    const handleCloseReportMenu = () => {
        setAnchorElReport(null);
    };
    const handleClickMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };
    const handleFileUpload = async () => {
        const response = await uploadExcel(selectedDocument);
        response.success === true &&
        setShowSnackbar({
            status: true,
            message: response.data,
            severity: "success",
        });
    };
    const handleClose = () => {
        setOpenDialog({...openDialog, show: false});
    };
    const handleDateChange = (date, field) => {
        const formattedDate = moment(date).format("YYYY-MM-DD");

        if (field === "fromDate") {
            setFromDate(formattedDate);

            const adjustedToDate = moment(formattedDate).add(15, "days").format("YYYY-MM-DD");
            setToDate(adjustedToDate);
        } else if (field === "toDate") {
            const formattedToDate = moment(date).format("YYYY-MM-DD");

            const maxAllowedToDate = moment(fromDate).add(15, "days").format("YYYY-MM-DD");

            if (moment(formattedToDate).isAfter(maxAllowedToDate)) {
                const adjustedFromDate = moment(formattedToDate).subtract(15, "days").format("YYYY-MM-DD");
                setFromDate(adjustedFromDate);
                setToDate(formattedToDate);
            }
            // else if (moment(formattedToDate).isBefore(fromDate)) {
            //     const adjustedFromDate = moment(formattedToDate).subtract(15, "days").format("YYYY-MM-DD");
            //     setFromDate(adjustedFromDate);
            else {
                setToDate(formattedToDate);
            }
        }
    };



    const handleDownloadDocument = () => {
        openDialog.show === true && setDownloading(true);
        openDialog.type === "claimReport" &&
        openDialog.show !== false &&
        downloadExcelFile(fromDate, toDate);
        openDialog.type === "claimStageReport" &&
        openDialog.show !== false &&
        downloadClaimStageWiseReport(fromDate, toDate);
        openDialog.type === "bussinessReport" &&
        openDialog.show !== false &&
        downloadBusinessReport(
            fromDate,
            toDate,
            excludeFailedCase,
            includeInsurerFinal
        );
        openDialog.type === "tariffTestingReport" &&
        openDialog.show !== false &&
        downloadTariffTestingReport(fromDate, toDate);
        openDialog.type === "tariffReport" &&
        openDialog.show !== false &&
        downloadTariffReport(fromDate, toDate);
    };
    const downloadExcelFile = async (startDate, endDate) => {
        await getExcelData(startDate, endDate);
        setDownloading(false);
        setOpenDialog({show: false, type: ""});
    };
    const downloadClaimStageWiseReport = async (startDate, endDate) => {
        await getClaimStageReport(startDate, endDate);
        setDownloading(false);
        setOpenDialog({show: false, type: ""});
    };
    const downloadBusinessReport = async (
        startDate,
        endDate,
        excludeFailedCase,
        includeInsurerFinal
    ) => {
        await getBusinesReport(
            startDate,
            endDate,
            excludeFailedCase,
            includeInsurerFinal
        );
        setDownloading(false);
        setOpenDialog({show: false, type: ""});
    };
    const downloadTariffTestingReport = async (startDate, endDate) => {
        await getTariffTestingReport(startDate, endDate);
        setDownloading(false);
        setOpenDialog({show: false, type: ""});
    };
    const downloadTariffReport = async (startDate, endDate) => {
        await getTariffReport(startDate, endDate);
        setDownloading(false);
        setOpenDialog({show: false, type: ""});
    };

    return (
        <AppBar
            ref={appbarRef}
            color="primary"
            elevation={2}
            position="static"
            style={{maxHeight: "4rem"}}
        >
            <Toolbar disableGutters sx={{m: "0 0.5rem"}}>
                <Box sx={{display: "flex", flexGrow: 1, gap: "1.5rem"}}>
                    <img
                        src={Logo}
                        style={{
                            width: "auto",
                            height: isSmall ? "30px" : "50px",
                            cursor: !isIframeUser() ? "pointer" : "default",
                            padding: "1rem 0",
                        }}
                        onClick={() => {
                            if (!isIframeUser()) {
                                navigate("/")
                            }
                        }}
                        alt="Vitraya Logo"
                    />
                    {
                        !isIframeAndInsurerUser() &&
                        <Grid style={{marginTop: 25}}>
                            <CreateClaim
                                onChange={handleFile}
                                setShowSnackbar={setShowSnackbar}
                            />

                        </Grid>
                    }
                    {isVitrayaInternalUser() && (
                        <Grid item style={{marginTop: 25}}>
                            <Button
                                variant="text"
                                color="inherit"
                                //startIcon={<AdminPanelSettingsIcon />}
                                aria-controls={open ? "demo-positioned-menu" : undefined}
                                aria-haspopup="true"
                                aria-expanded={open ? "true" : undefined}
                                onClick={handleClickMenu}
                            >
                                On Boarding
                            </Button>
                            <Menu
                                id="demo-positioned-menu"
                                aria-labelledby="demo-positioned-button"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleCloseMenu}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                }}
                            >
                                <MenuItem onClick={() => navigate("/onboarding-hospital")}>
                                    <ListItemIcon>
                                        <LocalHospitalIcon/>
                                    </ListItemIcon>
                                    Hospital Onboarding
                                </MenuItem>
                                <MenuItem onClick={() => navigate("/onboarding-rooms")}>
                                    <ListItemIcon>
                                        <LocalHospitalIcon/>
                                    </ListItemIcon>
                                    Rooms Onboarding
                                </MenuItem>
                            </Menu>
                        </Grid>
                    )}
                    {isVitrayaInternalUser() && (
                        <Grid item style={{marginTop: 25}}>
                            <Button
                                variant="text"
                                color="inherit"
                                //startIcon={<AdminPanelSettingsIcon />}
                                // aria-controls={open ? "demo-positioned-menu" : undefined}
                                // aria-haspopup="true"
                                // aria-expanded={open ? "true" : undefined}
                                onClick={handleOpenReportMenu}
                            >
                                Reports
                            </Button>
                            <Menu
                                id="demo-positioned-menu"
                                aria-labelledby="demo-positioned-button"
                                anchorEl={anchorElReport}
                                open={Boolean(anchorElReport)}
                                onClose={handleCloseReportMenu}
                                anchorOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                }}
                            >
                                <MenuItem onClick={() => navigate("/report-claim-processing")}>
                                    <ListItemIcon>
                                        <AttachmentIcon/>
                                    </ListItemIcon>
                                    Claim Processing Report
                                </MenuItem>
                                <MenuItem onClick={() => navigate("/report-response-log")}>
                                    <ListItemIcon>
                                        <AttachmentIcon/>
                                    </ListItemIcon>
                                    Request and Response Log Report
                                </MenuItem>

                            
                                <MenuItem onClick={()=> navigate("/checkpointLogs")}>
                                    <ListItemIcon>
                                        <AttachmentIcon/>
                                    </ListItemIcon>
                                    CheckPoints Logs
                                </MenuItem>


                                <MenuItem
                                    onClick={() =>
                                        setOpenDialog({show: true, type: "bussinessReport"})
                                    }
                                >
                                    <ListItemIcon>
                                        <FileDownloadIcon/>
                                    </ListItemIcon>
                                    Download Business Report
                                </MenuItem>
                                <MenuItem
                                    onClick={() =>
                                        setOpenDialog({show: true, type: "tariffTestingReport"})
                                    }
                                >
                                    <ListItemIcon>
                                        <FileDownloadIcon/>
                                    </ListItemIcon>
                                    Download Tariff Testing Report
                                </MenuItem>
                                <MenuItem
                                    onClick={() =>
                                        setOpenDialog({show: true, type: "tariffReport"})
                                    }
                                >
                                    <ListItemIcon>
                                        <FileDownloadIcon/>
                                    </ListItemIcon>
                                    Download Tariff Line-item level Report
                                </MenuItem>
                                <MenuItem
                                    onClick={() =>
                                        setOpenDialog({show: true, type: "claimReport"})
                                    }
                                >
                                    <ListItemIcon>
                                        <FileDownloadIcon/>
                                    </ListItemIcon>
                                    Download Claim Report
                                </MenuItem>
                                <MenuItem
                                    onClick={() =>
                                        setOpenDialog({show: true, type: "claimStageReport"})
                                    }
                                >
                                    <ListItemIcon>
                                        <FileDownloadIcon/>
                                    </ListItemIcon>
                                    Download Stage-wise Claims Report
                                </MenuItem>
                            </Menu>
                        </Grid>
                    )}

                    {isIframeAndAdminUser() && (
                        <Grid item style={{marginTop: 25}}>
                            <Button
                                variant="text"
                                color="inherit"
                                // endIcon={<FileDownloadIcon />}
                                onClick={() =>
                                    setOpenDialog({show: true, type: "claimStageReport"})
                                }
                            >
                                Download Claim Report
                            </Button>
                        </Grid>
                    )}
                </Box>
                <Box sx={{display: "flex", alignItems: "center", gap: 2}}>
                    <Box
                        sx={{display: "flex"}}
                        onClick={handleOpenUserMenu}
                        style={{cursor: "pointer"}}
                    >
                        <Typography color="background" variant="body2">
                            {` ${email}`}
                        </Typography>
                    </Box>
                    <IconButton onClick={handleOpenUserMenu} sx={{p: 0}}>
                        <Avatar
                            alt={"varshath"}
                            style={{color: "#2A5DB4", background: "#fff"}}
                        />
                    </IconButton>

                    <Menu
                        sx={{mt: "45px"}}
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                    >
                        {isVitrayaInternalUser() && (
                            <MenuItem onClick={() => navigate("/signup")}>
                                <ListItemIcon>
                                    <PersonAddIcon/>
                                </ListItemIcon>
                                Create Users
                            </MenuItem>
                        )}

                        <MenuItem key={"logout"} onClick={logoutHandler}>
                            <ListItemIcon>
                                <LogoutIcon/>
                            </ListItemIcon>
                            <Typography textAlign="center">LogOut</Typography>
                        </MenuItem>
                    </Menu>
                    <Dialog open={openDialog.show} onClose={handleClose}>
                        <DialogTitle>
                            Choose the date for downloading the report
                        </DialogTitle>
                        <Divider/>
                        <Grid
                            style={{
                                padding: openDialog.type === "bussinessReport" ? "3%" : "10%",
                                maxWidth: "fit-content",
                            }}
                        >
                            {downloading === false && (
                                <Grid
                                    container
                                    gap={"10px"}
                                    display={"flex"}
                                    flexDirection={"column"}
                                    justifyContent={"center"}
                                    width={"auto"}
                                    marginBottom={"2%"}
                                >
                                    {openDialog.type === "bussinessReport" && (
                                        <Grid
                                            item
                                            display={"flex"}
                                            justifyContent={"space-between"}
                                        >
                                            <Grid style={{marginTop: 30}}>
                                                <Checkbox
                                                    checked={excludeFailedCase}
                                                    onChange={(event) =>
                                                        setExcludeFailedCase(event.target.checked)
                                                    }
                                                    inputProps={{"aria-label": "controlled"}}
                                                />
                                                <label>Exclude failed cases</label>
                                            </Grid>
                                            <Grid style={{marginTop: 30}}>
                                                <Checkbox
                                                    checked={includeInsurerFinal}
                                                    onChange={(event) =>
                                                        setIncludeInsurerFinal(event.target.checked)
                                                    }
                                                    inputProps={{"aria-label": "controlled"}}
                                                />
                                                <label>Include insurer final only</label>
                                            </Grid>
                                        </Grid>
                                    )}

                                    <Grid
                                        item
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: 10,
                                        }}
                                    >
                                        <Grid item>
                                            <DateFilter
                                                disableFuture={true}
                                                fieldId={"fromDate"}
                                                selectedDate={fromDate}
                                                onDateChange={handleDateChange}
                                                // minDate={moment(toDate).subtract(15, "days").toDate()}
                                                maxDate={today || toDate}
                                            />
                                        </Grid>

                                        <Grid item>
                                            <Typography variant="subtitle2" display="inline">
                                                To
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <DateFilter
                                                disableFuture={true}
                                                fieldId={"toDate"}
                                                selectedDate={toDate}
                                                onDateChange={handleDateChange}
                                                minDate={fromDate}
                                                maxDate={today || moment(fromDate).add(15,"days").toDate() }
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                            {downloading === true && (
                                <Grid style={{padding: "5%"}} textAlign={"center"}>
                                    <b> Downloading.......</b>
                                </Grid>
                            )}
                        </Grid>

                        <DialogActions>
                            <Button variant="outlined" onClick={handleClose} color="primary">
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleDownloadDocument}
                                disabled={downloading}
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
            </Toolbar>
        </AppBar>
    );
};
export default Header;
